import { render, staticRenderFns } from "./simple-select.vue?vue&type=template&id=94653a2c&scoped=true&"
import script from "./simple-select.vue?vue&type=script&lang=js&"
export * from "./simple-select.vue?vue&type=script&lang=js&"
import style0 from "./simple-select.vue?vue&type=style&index=0&id=94653a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94653a2c",
  null
  
)

export default component.exports